import { encode, decode } from '../helpers/cryptIndex';
import emitter from '../helpers/emitter';

/**
 * encrypt cardId
 */
export const encrypt = (cardId) => {
  const id = cardId.split('-').join('').split('');
  const list = encode();
  let newId = '';
  id.forEach((element) => {
    newId += list[element];
  });

  return newId.split('').reverse().join('');
};

/**
 * decrypt cardId
 */
export const decrypt = (cardId) => {
  const regex = /^[a-fA-F0-9]+$/;

  if (cardId.length !== 32 || !regex.test(cardId)) {
    console.log('here');
    emitter.emit('callMessager', {
      message: '請確認連結是否正確。',
      action: () => (window.location.href = process.env.VUE_APP_SHARE_URL),
    });
    return 'error';
  }
  const id = cardId.split('').reverse();

  const list = decode();
  let newId = '';
  id.forEach((element) => {
    newId += list[element];
  });

  const finalId = `${newId.substr(0, 8)}-${newId.substr(8, 4)}-${newId.substr(
    12,
    4,
  )}-${newId.substr(16, 4)}-${newId.substr(20, 12)}`;

  return finalId;
};
